module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/8497ec35ed4222582ad88b954851814c.jpg";